/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil';
import XLSX from "xlsx";
import Swal from 'sweetalert2'

import iconavatar from '../images/icon-avatar.svg'
import moment from 'moment'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import HomeIcon from '@material-ui/icons/Home';
import SearchIcon from '@material-ui/icons/Search';


import axios from 'axios';
import InputGroup from 'react-bootstrap/InputGroup'
import { Col, FormControl, Row, ListGroup, Media } from 'react-bootstrap';
import { Navbar, Nav, Form } from 'react-bootstrap'

import Card from 'react-bootstrap/Card'
import { Icon } from './Icon'
// import Select from 'react-select';
// import { DateTime } from './share';

import { history } from '../router/route';
import { personState } from "../store"

const BeaconLacation = (props) => {
    const d = new Date();
    const startDate = new Date();
    const [logs, setLogs] = useState([])
    const [temps, setTemps] = useState([])
    // const [beacons, setBeacons] = useState([])
    const [beaconsTemp, setBeaconsTemp] = useState([{ value: null, label: 'All' }])
    const [selectTemp, setSelectTemp] = useState({ value: null, label: 'All' })
    // const [beacon, setBeacon] = useState(null)
    const [dateRange, setDateRange] = useState([new Date(startDate.setDate(d.getDate() - 0)), d]);
    const user = useRecoilValue(personState)

    // const [excel_data, setExcelData] = useState([])


    // useEffect(() => {
    //   let isMounted = true; // note this mounted flag
    //   requestChartUsage();
    //   // convertData()
    //   return () => {
    //     isMounted = false;
    //   };

    // }, []);

    useEffect(() => {
        requestBeacons()
    }, [dateRange])

    async function requestBeacons() {
        const params = {
            "work": "BEACON.LIST",
            "item_per_request": 100,
            "current_item_amount": 0
        }
        const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
            auth: {
                username: process.env.REACT_APP_USERNAME,
                password: process.env.REACT_APP_PASSWORD
            }
        });
        if (res.data.status === true) {
            console.log(res.data.result)
            var bTemps = []
            bTemps.push({ value: null, label: 'All' })
            res.data.result.forEach(element => {
                bTemps.push({ value: element.rxid, label: element.code_name })
            });
            setBeaconsTemp(bTemps)
            if (selectTemp === null) {
                console.log(bTemps(0))
                setSelectTemp(bTemps(0))
                requestBeaconLogs(bTemps(1).value)
            } else {
                requestBeaconLogs(selectTemp.value)
            }

        }
    }
    async function requestBeaconLogs(rxid) {
        console.log(rxid)
        // var beforeDate = moment().add(-1, 'M');
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON_LOG.GET_BY_RXID",
                "item_per_request": 50000,
                "current_item_amount": itemCount,
                "rxid": rxid,
                "start": {
                    "date": parseInt(moment(dateRange[0]).format("DD")),
                    "month": parseInt(moment(dateRange[0]).format("MM")),
                    "year": parseInt(moment(dateRange[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((dateRange[1] !== null) ? moment(dateRange[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }

            const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
                auth: {
                    username: process.env.REACT_APP_USERNAME,
                    password: process.env.REACT_APP_PASSWORD
                }
            });
            if (res.data.status === true) {
                if (res.data.result.length > 0) {
                    console.log(res.data.result)
                    temp.push(...res.data.result)
                    itemCount += res.data.result.length
                } else {
                    finish = true
                }
            } else {
                finish = true
            }
        } while (!finish)
        setLogs(temp)
        setTemps(temp)
        Swal.close()
    }

    async function requestLogs(value) {
        // var beforeDate = moment().add(-1, 'M');
        var finish = false
        var itemCount = 0
        var temp = []
        Swal.fire({
            html: 'กำลังโหลดข้อมูล <b></b>%',
            // timer: 2000,
            timerProgressBar: true,
            allowOutsideClick: false
        })
        Swal.isVisible()
        Swal.showLoading()
        do {
            const params = {
                "work": "BEACON_LOG.GET_BY_RXID",
                "item_per_request": 50000,
                "current_item_amount": itemCount,
                "rxid": selectTemp.value,
                "start": {
                    "date": parseInt(moment(value[0]).format("DD")),
                    "month": parseInt(moment(value[0]).format("MM")),
                    "year": parseInt(moment(value[0]).format("YYYY")),
                    "hour": 0,
                    "minute": 0
                },
                "end": {
                    "date": parseInt((value[1] !== null) ? moment(value[1]).format("DD") : new Date().getDay()),
                    "month": parseInt((value[1] !== null) ? moment(value[1]).format("MM") : new Date().getMonth()),
                    "year": parseInt((value[1] !== null) ? moment(value[1]).format("YYYY") : new Date().getFullYear()),
                    "hour": 23,
                    "minute": 59
                }
            }

            const res = await axios.post(`${process.env.REACT_APP_BEV_API}/v3/apis/beacon`, params, {
                auth: {
                    username: process.env.REACT_APP_USERNAME,
                    password: process.env.REACT_APP_PASSWORD
                }
            });
            if (res.data.status === true) {
                if (res.data.result.length > 0) {
                    temp.push(...res.data.result)
                    itemCount += res.data.result.length
                } else {
                    finish = true
                }
            } else {
                finish = true
            }
        } while (!finish)
        // setLogs(temp)
        // setTemps(temp)
        Swal.close()
    }


    // const time = (t)=>{
    //   if (t>60){
    //     return `${Math.floor(Math.floor(t)/60)} นาที ${Math.floor(t)%60} วินาที`
    //   }else{
    //     return `${Math.floor(t)} วินาที`
    //   }

    // }

    const loadData = () => {
        let tempex = []
        logs.map((row, i) => {
            // if(i===0){
            //   tempex.push(["คลาสหน้าจอ","จำนวนครั้ง","จำนวนคน","เวลาเฉลี่ย"]);
            // }
            var obj = { "วัน": `${moment(row._cd).utc().format('DD/MM/YYYY')}`, "เวลา": `${moment(row._cd).utc().format('HH:mm:ss')}`, "beacon_id": `${row.beacon.minor_id}`, "ชื่อสถานที่": `${row.beacon.code_name}`, "รหัสพนักงาน": `${row.emp_id}`, "ชื่อ": `${row.person.first_name}`, "นามสกุล": `${row.person.last_name}`, "ละติจูด": `${row.location.latitude}`, "ลองติจูด": `${row.location.longitude}`, "ระยะ": `${row.meter}`, "รุ่นโทรศัพท์": row.device ? `${row.device ? row.device.brand : ''}, ${row.device ? row.device.model : ''}` : '-' }
            tempex.push(obj);
        })

        const ws = XLSX.utils.json_to_sheet(tempex);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, selectTemp.code_name);
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `Beacon Log_${moment().format("DDMMYYYY-HH:mm:ss")}.xlsx`);
    }

    const searchEmp = (emp) => {
        var result = temps.filter(function (el) {
            return el.emp_id.indexOf(emp) !== -1
        });
        setTemps(result)
    }

    const onSelectChange = value => {
        // this.toggleOpen();
        setSelectTemp(value) || requestBeaconLogs(value.value)
    }

    const onSelectDate = value => {
        setDateRange(value)
        if (value[1] !== null) {
            requestLogs(value)
        }

    }
    function onClickToDetail() {
        history.push('/beacons-location-detail/DASDeERSFFDFSFW')
    }

    return (
        <>
            <Navbar bg="white" variant="white" className=''>
                <Navbar.Brand href="/">
                    <HomeIcon />
                </Navbar.Brand>
                <span className='navbar-text'>
                    <div className="media">
                        <Icon
                            className="align-self-center mr-1 text-green"
                            // width={16}
                            height={24}
                            aria-hidden="true"
                            icon='BuildingIcon'
                        />
                        <div className="media-body d-flex align-items-center">
                            <p className="mb-0 font-weight-bolder">All Locations</p>
                        </div>
                    </div>
                </span>
                <Nav className="mr-auto" />



                <div class="media px-2">
                    <img src={iconavatar} alt={user ? user.profile ? user.profile.sub : '' : ''} className="align-self-center" />
                    <div class="media-body">
                        <p class="mb-0">{user ? user.profile ? user.profile.sub : '' : ''}</p>
                    </div>
                </div>

            </Navbar>
            <Card className="mb-0 border rounded-0">
                <Card.Body className='py-2'>
                    <div className="d-flex justify-content-between">
                        <h6 className="mb-0 d-flex align-items-center">Locations List</h6>
                        <Form inline>
                            <InputGroup.Prepend className='position-absolute'>
                                <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                    <SearchIcon></SearchIcon>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                type="text"
                                className="mr-sm-2"
                                placeholder="ค้นหา"
                                style={{ paddingLeft: '2.5rem' }}
                            />
                            {/* <Button variant="outline-primary">Search</Button> */}
                        </Form>
                    </div>

                </Card.Body>
            </Card>
            {/* <Container className='border-0' fluid> */}
            {/* <Card.Header className="bg-white">
                <Row>
                    <Col>
                        <Card.Title className="py-2 mb-0">Locations List</Card.Title>
                    </Col>
                    <Col>
                        <div className="float-right">
                            <InputGroup.Prepend className='position-absolute'>
                                <InputGroup.Text id="basic-addon1" className="bg-white border-0 bg-transparent mt-1">
                                    <SearchIcon></SearchIcon>
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                            <FormControl
                                aria-label="search"
                                aria-describedby="basic-addon1"
                                type="text"
                                placeholder="ค้นหา"
                                style={{ width: 320, paddingLeft: '2.5rem' }}
                                onChange={(e) => searchEmp(e.target.value)}
                            />
                        </div>
                    </Col>
                </Row>
            </Card.Header> */}
            {/* <Card> */}
            <ListGroup>
                {logs.map((log, key) => (
                        <ListGroup.Item action onClick={onClickToDetail} variant="flush" className="border-top-0" key={key}>
                            <Row>
                                <Col xs="3" className="px-2 d-flex align-items-center">
                                    <div className="d-flex align-items-center">
                                        <Icon
                                            className="align-self-center mr-1 text-green"
                                            // width={30}
                                            height={24}
                                            aria-hidden="true"
                                            icon='BuildingIcon'
                                        />
                                        <Media.Body >
                                            <h6 className="mb-1 font-weight-bolder">ตึกแสงโสม</h6>
                                            <p className="mb-0">
                                                8 ZONES
                                            </p>
                                        </Media.Body>
                                    </div>
                                </Col>
                                <Col xs="2" className="d-flex align-items-center px-2">
                                    <Icon
                                        icon="BeaconIcon"
                                        width={24}
                                        height={24}
                                        className="text-green"
                                    ></Icon>
                                    <p className="mb-0 font-weight-bolder">25 Beacon</p>
                                </Col>
                                <Col xs="2" className="px-2">
                                    <address>1355 Market St, Suite 900
                                        San Francisco, CA 94103</address>
                                </Col>
                                <Col xs="2" className="px-2">
                                    <p className="mb-0 font-weight-bolder">ละติจูด</p>
                                    <p className="mb-0">{log.location.latitude}</p>
                                </Col>
                                <Col xs="2" className="px-2">
                                    <p className="mb-0 font-weight-bolder">ลองติจูด</p>
                                    <p className="mb-0">{log.location.longitude}</p>
                                </Col>
                                <Col xs="1" className="d-flex align-items-center justify-content-end px-1">
                                    <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
                                </Col>

                            </Row>
                        </ListGroup.Item>
                    )
                )}
                <ListGroup.Item onClick={onClickToDetail} variant="flush">
                    <Row>
                        <Col xs="3" className="px-2 d-flex align-items-center">
                            <div className="d-flex align-items-center">
                                <Icon
                                    className="align-self-center mr-1 text-green"
                                    // width={30}
                                    height={24}
                                    aria-hidden="true"
                                    icon='BuildingIcon'
                                />
                                <Media.Body >
                                    <h6 className="mb-1 font-weight-bolder">ตึกแสงโสม</h6>
                                    <p className="mb-0">
                                        8 ZONES
                                    </p>
                                </Media.Body>
                            </div>
                        </Col>
                        <Col xs="2" className="d-flex align-items-center px-2">
                            <Icon
                                icon="BeaconIcon"
                                width={24}
                                height={24}
                                className="text-green"
                            ></Icon>
                            <p className="mb-0 font-weight-bolder">25 Beacon</p>
                        </Col>
                        <Col xs="2" className="px-2">
                            <address>1355 Market St, Suite 900
                                San Francisco, CA 94103</address>
                        </Col>
                        <Col xs="2" className="px-2">
                            <p className="mb-0 font-weight-bolder">ละติจูด</p>
                            <p className="mb-0">1.6555555489</p>
                        </Col>
                        <Col xs="2" className="px-2">
                            <p className="mb-0 font-weight-bolder">ลองติจูด</p>
                            <p className="mb-0">90.54444545</p>
                        </Col>
                        <Col xs="1" className="d-flex align-items-center justify-content-end px-1">
                            <ArrowForwardIosIcon color='primary'></ArrowForwardIosIcon>
                        </Col>

                    </Row>
                </ListGroup.Item>

            </ListGroup>
            {/* </Card> */}
            {/* </Container> */}
        </>
    )

}

export default BeaconLacation